import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { ConnectionPositionPair } from '@angular/cdk/overlay';

import { AfterViewInit, ChangeDetectorRef, Component, ComponentRef, Inject, Input, OnInit, ViewChild, DOCUMENT } from '@angular/core';
import { ViewRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { fromEvent, Subject } from 'rxjs';
import { CardView } from 'src/app/interfaces/cardview';
import { REGISTRY } from 'src/app/interfaces/registry-services';
import { HTTPService } from 'src/app/services/http.service';
import { PermissionServices } from 'src/app/services/permission.services';
import { ThemeService } from 'src/app/services/theme.service';
import { UserAuthenticationServices } from 'src/app/services/user-authentication.services';
import { UserConfigServices } from 'src/app/services/user-config.services';
import { ObjectUtil } from 'src/app/system-utils/utils/ObjectUtil';

export interface MartkePlaceTabs{
  entityName:string; 
  name:string;
  iconName:string; 
  iconClass:string, 
  componentName?:string, 
  className:string, 
  order:number;
  canAccess:Boolean;
  templateId?:number; // ID do template do builder-screen para modo inclusão
}

@Component({
    selector: 'marketplace-tabs',
    templateUrl: './market-place-tabs.component.html',
    styleUrls: ['./market-place-tabs.component.scss'],
    standalone: false
})
export class MarketPlaceTabsComponent implements OnInit, AfterViewInit {

  row:CardView = null;
  @Input()parentRow;
  isOpen = false;
  subscription;
  subscription1;
  controlPressed = false;
  
  
  positionPairs: ConnectionPositionPair[] = [
    {
      offsetX: 0,
      offsetY: 0,
      originX: 'center',
      originY: 'top',
      overlayX: 'center',
      overlayY: 'top',
      panelClass: null,
    },
  ];

  marketPlaceTabs:MartkePlaceTabs[] =[];
  realMarketPlaceTabs:MartkePlaceTabs[] =[];
  savedMarketPlaceTabs:MartkePlaceTabs[] =[];
  eventsSubject: Subject<string> = new Subject<string>();
  userId: number;
  userConfig;
  fakeInsert;

  /** spinner NG-ZORRO (substitui o ngx-spinner) */
  loading = false;

  constructor(private ap: PermissionServices, private cd:ChangeDetectorRef,@Inject(DOCUMENT) private document: Document,
  private http:HTTPService, private uas:UserAuthenticationServices,
  private ucs:UserConfigServices,
  public ThemeService:ThemeService) {
      this.marketPlaceTabs = this.uas.user.marketPlaceTabs as MartkePlaceTabs[];
   }

   checkPermission(){
        this.realMarketPlaceTabs = this.marketPlaceTabs.filter(d=>{
          let canAccess = this.checkAccess(d.entityName);
          d.canAccess = canAccess;
          let saved = this.savedMarketPlaceTabs.find(x=>x.name == d.name );
          if ( saved!= null){
            d.order = saved.order;
          }
            
          return d.canAccess;
        });
      
        this.sort();
   }
  ngOnInit() {
    this.userId = this.uas.user.iduser;
    this.loading = true;
    this.ucs.loadUserConfig(this.userId, 'Mktpproducts').subscribe({
        next:(response)=>{
          if ( response['Mktpusercfg'][0]){
            if ( ObjectUtil.isNotEmpty( response['Mktpusercfg'][0]['CONFIG'])){
              this.userConfig = JSON.parse(response['Mktpusercfg'][0]['CONFIG'])
            }
          }

          if ( this.userConfig ){
            if ( this.userConfig['marketplaceTabs']){
              this.savedMarketPlaceTabs = JSON.parse(JSON.stringify(this.userConfig['marketplaceTabs']));
            }
          }
          
          //if ( this.realMarketPlaceTabs == null || this.realMarketPlaceTabs == [] ){
            //this.realMarketPlaceTabs = this.marketPlaceTabs;
          //}

          this.checkPermission();
          this.loading = false;
        },
        error:(error)=>{
          this.loading = false;
          throw error;
        }
    });

     this.row = this.parentRow;
     
     

     this.subscription = fromEvent<KeyboardEvent>(this.document, 'keydown').subscribe(
      (event: KeyboardEvent) => {
        if (event.ctrlKey) {
          this.controlPressed = true;
        } else {
          this.controlPressed = false;
        }       
      }
    );

    this.subscription1 = fromEvent<KeyboardEvent>(this.document, 'keyup').subscribe(
      (event: KeyboardEvent) => {
        this.controlPressed = false;
      }
    );

  }

  
  sort(){
    this.realMarketPlaceTabs.sort((a,b)=>{
      if ( a.order > b.order ){
        return 1;
      }
      if ( a.order < b.order ){
        return -1;
      }
      return 0;
   });
  }

  ngAfterViewInit(){
  }

  ngOnDestroy(){
    if ( this.subscription != null ){ this.subscription.unsubscribe();}
    if ( this.subscription1 != null ){ this.subscription1.unsubscribe();}
    this.cd.detach();
  }

  clickedRow(row:CardView){
    this.row = row;
    setTimeout(()=>{
      //this.editface = true;

      setTimeout(() => {
        if (this.cd !== null && this.cd !== undefined &&
          !(this.cd as ViewRef).destroyed) {
          this.cd.detectChanges();
        }
        }, 250);
      
    },700)
  }

  
  checkAccess(entityName:string):Boolean{
      let canAccess = this.ap.checkPermissionSession(entityName,'view');
      return canAccess;
  }

  array_move(arr, old_index, new_index) {
    if (new_index >= arr.length) {
        var k = new_index - arr.length + 1;
        while (k--) {
            arr.push(undefined);
        }
    }
    arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
    return arr; // for testing
  };
  
  salvarConfig(){
      return new Promise((resolve, reject) => {

        if ( this.userConfig == null ){
          this.userConfig = {
            marketplaceTabs:this.realMarketPlaceTabs
          }
        }else{
          this.userConfig['marketplaceTabs'] = this.realMarketPlaceTabs;
        }


        let jsonSave: Object = {
          entityName: "Mktpusercfg",
          IDINSTANCE:60,
          IDUSER: this.uas.user.iduser,
          CONFIG: JSON.stringify(this.userConfig)
          //IDINSTANCE: this.itemSelectedInstance.id,
          //IDUSER: this.userSelectedItem.id,
        };
  
        this.http.post(jsonSave, "JsonBrokerServices/save", true).subscribe();
        this.controlPressed = false;
        this.isOpen = false;
      });
    
  }

  
  drop(event: CdkDragDrop<MartkePlaceTabs[]>) {    
    
    this.realMarketPlaceTabs[event.previousIndex].order = event.currentIndex;
    this.realMarketPlaceTabs[event.currentIndex].order = event.previousIndex;
    this.sort();
    
    let oldMarketPlace = JSON.parse(JSON.stringify(this.realMarketPlaceTabs));
    this.realMarketPlaceTabs = [];
    this.realMarketPlaceTabs = [...oldMarketPlace];
    
  }

  onRightClick(event) {
    event.preventDefault();
    this.isOpen=false;
    if (this.controlPressed){
      this.isOpen=true;
    }else{
      this.isOpen=false;
    }
   }
}

